import cati from '@/app/module/cati/store/state'
import contacts from '@/app/module/contacts/store/state'
import conversations from '@/app/module/conversations/store/state'
import customFields from '@/app/module/custom-fields/store/state'
import files from '@/app/module/files/store/state'
import groups from '@/app/module/groups/store/state'
import logs from '@/app/module/logs/store/state'
import notifications from '@/app/module/notifications/store/state'
import plans from '@/app/module/plans/store/state'
import segments from '@/app/module/segments/store/state'
import user from '@/app/module/user/store/state'
import utils from '@/app/module/utils/store/state'

import { esApi } from './api'

export const defaultState = {
  user,
  contacts,
  customFields,
  logs,
  conversations,
  notifications,
  utils,
  groups,
  segments,
  files,
  plans,
  cati,
  [esApi.reducerPath]: {},
}
